import { render, staticRenderFns } from "./MAN934P01.vue?vue&type=template&id=ed9be228&"
import script from "./MAN934P01.vue?vue&type=script&lang=js&"
export * from "./MAN934P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports